import { FormLabel, Select, SelectProps, TextField, TextFieldProps, FormControl, FormHelperText } from '@mui/material';
import React, { ReactNode } from 'react';

export function AddressInput(props: TextFieldProps): JSX.Element {
  const { id, label, required } = props;

  return (
    <AddressInputBase {...{ id, label, required }}>
      <TextField {...props} label={undefined} />
    </AddressInputBase>
  );
}

type AddressSelectProps = SelectProps & {
  error?: boolean;
  helperText?: React.ReactNode;
  helperTextId?: string;
};

export function AddressSelect(props: AddressSelectProps): JSX.Element {
  const { error, helperText, helperTextId, ...selectProps } = props;
  const { id, label, required } = selectProps;
  return (
    <AddressInputBase {...{ id, label, required }}>
      <FormControl fullWidth error={error}>
        <Select {...selectProps} label={undefined}>
          {selectProps.children}
        </Select>
        {error && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
      </FormControl>
    </AddressInputBase>
  );
}

function AddressInputBase(props: {
  id?: string;
  label?: ReactNode;
  required?: boolean;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <>
      <FormLabel htmlFor={props.id}>
        {props.label} {props.required && '*'}
      </FormLabel>
      {props.children}
    </>
  );
}
